import styled from '@emotion/styled'

import { Color } from '../../constants'
import { Icon } from '../Icon'

const Checkmark = styled(Icon)({
  svg: {
    color: Color.BLUE,
  },
})

export const SelectedCheckmark = (props: { selected: boolean }) => {
  return (
    <Checkmark
      name="CheckIcon"
      marginLeft="auto"
      size="sm"
      styles={{
        visibility: props.selected ? 'visible' : 'hidden',
      }}
    />
  )
}
